import React, { useContext, useState, useCallback, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Context } from "../../../index";
import CustomLink from "../../Shared/CustomLink/CustomLink";
import PrivacyPolicyLink from "../../Shared/PrivacyPolicyLink";
import Logo from "../../../assets/mainLogo.svg";
import Bacground from "../../../assets/backgroundLogin.jpg";

const ForgotPasswordForm = observer(() => {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [infoMode, setInfoMode] = useState(false);
    const { store } = useContext(Context);

    const isValidEmail = useCallback((email: string): boolean => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }, []);

    const validateEmail = useCallback((): boolean => {
        let emailErr = "";

        if (!email) {
            emailErr = "Введите email";
        } else if (!isValidEmail(email)) {
            emailErr = "Некорректный email";
        }

        setEmailError(emailErr);
        return emailErr !== "";
    }, [email, isValidEmail]);

    const handleConfirm = useCallback(async () => {
        if (validateEmail()) return;

        try {
            const res = await store.requestPasswordRecover(email);
            if (res === 404) {
                setEmailError("Не найден пользователь с таким email");
                return;
            }
            setInfoMode(true);
        } catch (err) {
            setEmailError("Произошла ошибка при отправке письма");
        }
    }, [email, store, validateEmail]);

    const handleEmailChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        if (emailError) setEmailError("");
    }, [emailError]);

    const handleBlur = useCallback(() => {
        validateEmail();
    }, [validateEmail]);

    const handleKeyPress = useCallback((e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
            handleConfirm();
        }
    }, [handleConfirm]);

    const infoContent = useMemo(() => (
        <div className="form_main_center">
            <div className="form_container form_container_fullscreen form_container_center">
                <div className="form_logo">
                    <img src={Logo} alt="Логотип компании" />
                </div>
                <div>
                    <h2 className="form_header form_text">Письмо отправлено на указанную почту</h2>
                </div>
                <div className="form_description">
                    <p className="form_text">
                        Для восстановления пароля перейдите по ссылке из письма
                    </p>
                </div>
                <div className="bottom_buttons">
                    <p className="p_blue p_14 pointer_custom">
                        <CustomLink to="/login">Вход</CustomLink>
                    </p>
                </div>
                <PrivacyPolicyLink />
            </div>
            <img
                src={Bacground}
                alt="Фон компании"
                className="background_image_fullscreen"
            />
        </div>
    ), []);

    const formContent = useMemo(() => (
        <div className="form_main_center" onKeyDown={handleKeyPress}>
            <div className="form_container form_container_fullscreen form_container_center">
                <div className="form_inner">
                    <div className="form_logo">
                        <img src={Logo} alt="Логотип компании" />
                    </div>
                    <div>
                        <h2 className="form_header">Восстановление пароля</h2>
                    </div>
                    <div className="form_description">
                        <p className="form_text">
                            Введите почту, чтобы мы отправили вам письмо для восстановления пароля
                        </p>
                    </div>
                    <div className={`input_form_login ${emailError ? "input_with_error" : ""}`}>
                        <label className="input_label" htmlFor="login_email">
                            Email*
                        </label>
                        <InputText
                            placeholder="email"
                            id="login_email"
                            value={email}
                            onBlur={handleBlur}
                            onChange={handleEmailChange}
                            className={emailError ? "p-invalid" : ""}
                        />
                        {emailError && <p className="error_message">{emailError}</p>}
                    </div>
                    <div className="login_btn">
                        <Button
                            label="Восстановить"
                            onClick={handleConfirm}
                            disabled={!email}
                        />
                    </div>
                    <div className="bottom_buttons form__margin-top">
                        <p className="p_blue p_14 pointer_custom">
                            <CustomLink to="/login">Вход</CustomLink>
                        </p>
                        <p className="p_blue p_14 pointer_custom">
                            <CustomLink to="/register">Регистрация</CustomLink>
                        </p>
                    </div>
                    <PrivacyPolicyLink />
                </div>
            </div>
            <img
                src={Bacground}
                alt="Фон компании"
                className="background_image_fullscreen"
            />
        </div>
    ), [email, emailError, handleBlur, handleEmailChange, handleConfirm, handleKeyPress]);

    return infoMode ? infoContent : formContent;
});

export default ForgotPasswordForm;